import { createSlice } from '@reduxjs/toolkit';
import { UserType } from '../../../types/user';
import { MetaType } from '../../../types';

interface UserState {
  users: UserType[];
  user: UserType;
  meta: MetaType;
}

const initialState: UserState = {
  users: [],
  user: <UserType>{},
  meta: <MetaType>{}
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAllUser(state, action) {
      state.users = action.payload.results || [];
      state.meta = action.payload.meta || <MetaType>{};
    },
    addOneUser(state, action) {
      state.users = [...state.users, action.payload.row];
    },
    setOneUser(state, action) {
      state.users = state.users.map(item => {
        if (item.id !== action.payload.id) return item;
        else return { ...item, ...action.payload.row };
      });
    },
    removeOneUser(state, action) {
      state.users = state.users.filter(item => item.id !== action.payload.id);
    }
  }
});

export const { setAllUser, addOneUser, setOneUser, removeOneUser } =
  userSlice.actions;
export default userSlice.reducer;
